<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
        <ModalApprovaRifiuta
            v-model:visible="approvaModalVisible"
            @approva="approvaFornitore(true)"
            @rifiuta="approvaFornitore(false)"
        >
            <template #title>Apporvazione fornitore</template>
            <template #content>Desideri approvare o rifiutare il fornitore?</template>
        </ModalApprovaRifiuta>
    </teleport>

    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <Alert v-if="show_error_form" :dismissable="true" @close="show_error_form = false"
                   class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
                Correggi gli errori di inserimento
            </Alert>
            <div class="py-10 flex justify-between items-center">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="primary" v-if="toApprove" @click="approvaModalVisible = !approvaModalVisible"
                                class="w-48 text-center mr-3 py-2 px-4 m-0">
                        Approva/Rifiuta
                    </NextButton>
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton variant="primary" @click="save"
                                class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
                    </NextButton>
                </div>
            </div>

            <div class="flex flex-col mb-3">
                <Field field_name="Aziende del gruppo"
                       placeholder="Aziende del gruppo">
                    <VueMultiselect
                        :multiple="true"
                        trackBy="id"
                        label="nome"
                        :disabled="true"
                        v-model="fornitore_model.aziende_gruppo"
                        :options="fornitore_model.aziende_gruppo"
                        placeholder="Aziende gruppo"
                        class="next-vue-multiselect"
                    >
                        <template v-slot:tag="{option, remove}">
                            <MultiselectOption @remove="remove(option)">
                                {{ option.nome }}
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <h3 class="text-3xl font-bold mb-6">Anagrafica - {{ fornitore_model?.denominazione }}</h3>

            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Anagrafica gamma</h6>

                <div v-if="hasPermission('set id_gamma')" class="flex flex-col pb-3 grow">
                    <Field field_name="ID gamma" type="number"
                           :errors="getErrors('id_gamma')">
                        <div class="relative flex items-center">
                            <input v-model="fornitore_model.id_gamma" type="number"
                                   class="p-2 bg-next-gray-md-dark hover:bg-white w-full pr-7">
                            <Spinner v-show="anagrafica_gamma_loading" class="w-5 absolute right-1 "></Spinner>
                        </div>
                    </Field>
                </div>

                <div v-if="anagrafica_gamma?.CG16_CODICE" class="grid grid-cols-2 col-span-2">
                    <span>Ragione sociale: {{ anagrafica_gamma.CG16_RAGSOANAG }}</span>
                    <span>Partita IVA: {{ anagrafica_gamma.CG16_PARTIVA }}</span>
                    <span>Codice fiscale: {{ anagrafica_gamma.CG16_CODFISCALE }}</span>
                    <span>Codice SDI: {{ anagrafica_gamma.CG1M_CODICE }}</span>
                </div>
                <div v-else class="pb-3">
                    <span>Azienda gamma non associata</span>
                </div>
            </div>

            <AnagraficaAzienda
                :errors="errors"
                v-model:lat="fornitore_model.a_lat"
                v-model:lng="fornitore_model.a_lng"
                v-model:place_id="fornitore_model.a_place_id"
                v-model:estera="fornitore_model.estera"
                v-model:tipo="fornitore_model.tipo"
                v-model:azienda_id="fornitore_model.azienda_id"
                v-model:partita_iva="fornitore_model.partita_iva"
                v-model:codice_fiscale="fornitore_model.codice_fiscale"
                v-model:ragione_sociale="fornitore_model.ragione_sociale"
                v-model:sede_legale_nazione_id="fornitore_model.sede_legale_nazione_id"
                v-model:sede_legale_provincia_id="fornitore_model.sede_legale_provincia_id"
                v-model:sede_legale_comune_id="fornitore_model.sede_legale_comune_id"
                v-model:sede_legale_regione_estero="fornitore_model.sede_legale_regione_estero"
                v-model:sede_legale_citta_estero="fornitore_model.sede_legale_citta_estero"
                v-model:sede_legale_via="fornitore_model.sede_legale_via"
                v-model:sede_legale_cap="fornitore_model.sede_legale_cap"
                v-model:sede_legale_numero="fornitore_model.sede_legale_numero"
            >
            </AnagraficaAzienda>

            <AnagraficaDenominazione
                :errors="errors"
                :disabled="disable_dati_denominazione"
                v-model:anagrafica_denominazione_id="fornitore_model.anagrafica_denominazione_id"
                v-model:denominazione="fornitore_model.denominazione"
                v-model:sito="fornitore_model.sito"
                v-model:gruppo_di_appartenenza="fornitore_model.gruppo_di_appartenenza"
                v-model:place_id="fornitore_model.place_id"
                v-model:lat="fornitore_model.lat"
                v-model:lng="fornitore_model.lng"
                v-model:sede_operativa_via="fornitore_model.sede_operativa_via"
                v-model:sede_operativa_numero="fornitore_model.sede_operativa_numero"
                v-model:sede_operativa_nazione_id="fornitore_model.sede_operativa_nazione_id"
                v-model:sede_operativa_cap="fornitore_model.sede_operativa_cap"
                v-model:sede_operativa_regione_estero="fornitore_model.sede_operativa_regione_estero"
                v-model:sede_operativa_citta_estero="fornitore_model.sede_operativa_citta_estero"
                v-model:sede_operativa_provincia_id="fornitore_model.sede_operativa_provincia_id"
                v-model:sede_operativa_comune_id="fornitore_model.sede_operativa_comune_id"
                v-model:email="fornitore_model.email"
                v-model:pec="fornitore_model.pec"
                v-model:telefono_1="fornitore_model.telefono_1"
                v-model:telefono_2="fornitore_model.telefono_2"
                v-model:fax="fornitore_model.fax"
            >
            </AnagraficaDenominazione>

            <div class="pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">IBAN</h6>

                <IbanForm v-model:ibans="fornitore_model.ibans" :errors="errors"></IbanForm>
            </div>

            <div class="grid xl:grid-cols-3 gap-4 py-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Assegnazioni
                    fornitore</h6>

                <div class="flex flex-col">
                    <Field field_name="Settore merceologico" :required="true" v-model="settoriSelections"
                           :errors="getErrors('settori_merceologici')">
                        <VueMultiselect
                            :searchable="true"
                            :internal-search="false"
                            :multiple="true"
                            trackBy="id"
                            label="descrizione"
                            @search-change="settore_merceologico_autocomplete.search"
                            v-model="settore_merceologico_autocomplete.selection"
                            :options="settore_merceologico_autocomplete.options"
                            :close-on-select="true" :clear-on-select="true"
                            placeholder="Settore"
                            deselectLabel="Deseleziona"
                            selectedLabel="Selezionato"
                            selectLabel="Seleziona"
                            class="next-vue-multiselect"
                        >
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.descrizione }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Qualifica" :required="true" v-model="fornitore_model.qualifica"
                           :errors="getErrors('qualifica')">
                        <VueMultiselect
                            :disabled="!hasPermission('approve fornitori')"
                            :searchable="true"
                            :internal-search="false"
                            :multiple="false"
                            trackBy="id"
                            label="text"
                            @search-change="qualifica_autocomplete.search"
                            v-model="qualifica_autocomplete.selection"
                            :options="qualifica_autocomplete.options"
                            :close-on-select="true" :clear-on-select="true"
                            placeholder="Qualifica"
                            deselectLabel="Deseleziona"
                            selectedLabel="Selezionato"
                            selectLabel="Seleziona"
                            class="next-vue-multiselect-single"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Accordo quadro"
                           :errors="getErrors('quadro_file_id')">
                        <div class="flex items-start">
                            <Checkbox
                                class="pt-3"
                                checkClass="h-4 w-4"
                                :checked="fornitore_model.accordo_quadro"
                                @change="fornitore_model.accordo_quadro = !fornitore_model.accordo_quadro"
                                for_id="quadro">
                            </Checkbox>

                            <FileUpload
                                v-model:uploaded_files="uploaded_quadro"
                                v-model:model_files="allegati_quadro"
                                v-model:to_delete="to_delete_quadro"
                                accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                            >
                                <template v-slot:default="{props, methods}">
                                    <div :class="{'invisible': !fornitore_model.accordo_quadro}"
                                         class="flex flex-col grow">
                                        <NextButton variant="outline-secondary" @click="methods.open"
                                                    class="w-full h-10 px-4 grow mb-2">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <div class="grid grid-cols-1 gap-3">
                                            <div v-show="uploaded_quadro.length">
                                                <span>Nuovo: </span>
                                                <a class="underline text-sm text-next-atp"
                                                   v-for="(f,idx) in uploaded_quadro">
                                                    <span>{{ f.name }}</span>
                                                </a>
                                            </div>
                                            <div>
                                                <span>Attualmente presente: </span>
                                                <a class="underline text-sm text-next-atp mb-1"
                                                   v-for="(f,idx) in allegati_quadro">
                                                    <span>{{ f.name }}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                    </div>
                                </template>
                            </FileUpload>
                        </div>
                    </Field>
                </div>

                <div v-show="requiredPolizze" class="grow flex">
                    <FileUpload
                        v-model:uploaded_files="uploaded_polizze"
                        v-model:model_files="allegati_polizze"
                        v-model:to_delete="to_delete_polizze"
                        multiple
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow gap-3">
                                <h3 class="font-bold justify-self-start">Polizza RCT/O</h3>
                                <div class="flex flex-col grow justify-end gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3  cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in allegati_polizze" :key="`a_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in uploaded_polizze_to_save" :key="`u_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_polizze" :key="`la_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_polizze_to_save" :key="`las_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                </div>
                                <NextButton variant="outline-secondary" @click="polizze_visible=true"
                                            class="w-full h-10 px-4">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                            </div>
                            <Modal :visible="polizze_visible" :backdrop="true">
                                <template #main>
                                    <div v-show="!uploaded_polizze.length" class="flex flex-col mb-5">
                                        <Field field_name="Link" v-model="polizze_link"></Field>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                        <small v-for="(e,i) in polizze_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                    <div v-show="!polizze_link.length" class="flex flex-col mb-5">
                                        <NextButton v-if="!uploaded_polizze.length" variant="outline-secondary"
                                                    @click="methods.open"
                                                    class="w-full h-10 px-4">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <template v-else>
                                            <Field v-for="(f,idx) in uploaded_polizze" :key="`u_${idx}`"
                                                   field_name="Allegato" v-model="f.name"
                                                   :input-attrs="{disabled:true}"></Field>
                                        </template>
                                    </div>
                                </template>
                                <template #footer>
                                    <div class="flex flex-col gap-3">
                                        <NextButton variant="primary" @click="salvaPolizze"
                                                    class="w-full h-10 px-4">Salva
                                        </NextButton>
                                        <NextButton variant="outline-primary" @click="methods.reset();chiudiPolizze()"
                                                    class="w-full h-10 px-4">Chiudi
                                        </NextButton>
                                    </div>
                                </template>
                            </Modal>

                        </template>
                    </FileUpload>
                </div>
                <div v-show="requiredVisure" class="grow flex">
                    <FileUpload
                        v-model:uploaded_files="uploaded_visure"
                        v-model:model_files="allegati_visure"
                        v-model:to_delete="to_delete_visure"
                        multiple
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow gap-3">
                                <h3 class="font-bold justify-self-start">Visura</h3>
                                <div class="flex flex-col grow justify-end gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in allegati_visure" :key="`a_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in uploaded_visure_to_save" :key="`u_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_visure" :key="`la_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_visure_to_save" :key="`las_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                </div>
                                <NextButton variant="outline-secondary" @click="visure_visible=true"
                                            class="w-full h-10 px-4">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                            </div>
                            <Modal :visible="visure_visible" :backdrop="true">
                                <template #main>
                                    <div v-show="!uploaded_visure.length" class="flex flex-col mb-5">
                                        <Field field_name="Link" v-model="visure_link"></Field>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                        <small v-for="(e,i) in visure_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                    <div v-show="!visure_link.length" class="flex flex-col mb-5">
                                        <NextButton v-if="!uploaded_visure.length" variant="outline-secondary"
                                                    @click="methods.open"
                                                    class="w-full h-10 px-4">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <template v-else>
                                            <Field v-for="(f,idx) in uploaded_visure" :key="`u_${idx}`"
                                                   field_name="Allegato" v-model="f.name"
                                                   :input-attrs="{disabled:true}"></Field>
                                        </template>
                                    </div>

                                </template>
                                <template #footer>
                                    <div class="flex flex-col gap-3">
                                        <NextButton variant="primary" @click="salvaVisure"
                                                    class="w-full h-10 px-4">Salva
                                        </NextButton>
                                        <NextButton variant="outline-primary" @click="methods.reset();chiudiVisure()"
                                                    class="w-full h-10 px-4">Chiudi
                                        </NextButton>
                                    </div>
                                </template>
                            </Modal>

                        </template>
                    </FileUpload>
                </div>
                <div v-show="requiredAlbi" class="grow flex">
                    <FileUpload
                        v-model:uploaded_files="uploaded_albo"
                        v-model:model_files="allegati_albo"
                        v-model:to_delete="to_delete_albo"
                        multiple
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow gap-3">
                                <h3 class="font-bold justify-self-start">Iscrizione albo gestori</h3>
                                <div class="flex flex-col grow justify-end gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in allegati_albo" :key="`a_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in uploaded_albo_to_save" :key="`u_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_albo" :key="`la_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_albo_to_save" :key="`las_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                </div>
                                <NextButton variant="outline-secondary" @click="albo_visible=true"
                                            class="w-full h-10 px-4">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                            </div>
                            <Modal :visible="albo_visible" :backdrop="true">
                                <template #main>
                                    <div v-show="!uploaded_albo.length" class="flex flex-col mb-5">
                                        <Field field_name="Link" v-model="albo_link"></Field>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                        <small v-for="(e,i) in albi_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                    <div v-show="!albo_link.length" class="flex flex-col mb-5">
                                        <NextButton v-if="!uploaded_albo.length" variant="outline-secondary"
                                                    @click="methods.open"
                                                    class="w-full h-10 px-4">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <template v-else>
                                            <Field v-for="(f,idx) in uploaded_albo" :key="`u_${idx}`"
                                                   field_name="Allegato" v-model="f.name"
                                                   :input-attrs="{disabled:true}"></Field>
                                        </template>
                                        <small v-for="(e,i) in albi_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                </template>
                                <template #footer>
                                    <div class="flex flex-col gap-3">
                                        <NextButton variant="primary" @click="salvaAlbo"
                                                    class="w-full h-10 px-4">Salva
                                        </NextButton>
                                        <NextButton variant="outline-primary" @click="methods.reset();chiudiAlbo()"
                                                    class="w-full h-10 px-4">Chiudi
                                        </NextButton>
                                    </div>
                                </template>
                            </Modal>

                        </template>
                    </FileUpload>
                </div>
            </div>


            <div class="flex flex-col mb-3">
                <div class="pb-2 font-bold text-sm">Note</div>
                <div class="flex justify-self-start bg-white">
                    <NextEditor v-model="fornitore_model.note"></NextEditor>
                </div>
            </div>

            <div class="grid xl:grid-cols-3 gap-4 py-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Allegati</h6>

                <div class="flex flex-col col-span-3">
                    <AllegatiUploader v-model:files="allegati" :errors="errors"></AllegatiUploader>
                </div>
            </div>

            <div class="flex justify-end pt-3">
                <NextButton variant="primary" @click="save"
                            class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
                </NextButton>
            </div>
        </div>

    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {Paths} from "@/types";
import {dettaglio_fornitore} from "@/BreadcrumbsPath";
import fornitoriManager from "../api/FornitoriManager";
import Autocomplete from "@/setup/Autocomplete";
import settoriMerceologiciManager from "../api/SettoriMerceologiciManager";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Loading from "@/components/Loading.vue";
import aziendeManager from "../api/Aziende";
import {ProvinciaComune} from "@/setup/ProvinciaComuneAutocomplete";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import NextEditor from "@/components/NextEditor.vue";
import FileUpload from "@/components/FileUpload.vue";
import Modal from "@/components/Modal.vue";
import linksManager from "../api/LinkManager";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import qualificheManager from "../api/QualificaManager";
import Checkbox from "@/components/Checkbox.vue";
import Spinner from "@/components/Spinner.vue";
import {mapGetters} from 'vuex';
import anagraficaGamma from "../api/AnagraficaGamma";
import Alert from "@/components/Alert.vue";
import Select from "@/components/Select.vue";
import ModalApprovaRifiuta from "@/components/ModalApprovaRifiuta.vue";
import IbanForm from "@/components/IbanForm.vue";
import AllegatiUploader from "@/components/AllegatiUploader.vue";
import MapViewer from "@/components/Address/MapViewer.vue";
import AnagraficaAzienda from "@/views/Anagrafica/AnagraficaAzienda.vue";
import AnagraficaDenominazione from "@/views/Anagrafica/AnagraficaDenominazione.vue";

@Options({
    name: 'DettaglioFornitore',
    components: {
        AnagraficaDenominazione,
        AnagraficaAzienda,
        MapViewer,
        AllegatiUploader,
        IbanForm,
        ModalApprovaRifiuta,
        Select,
        Alert,
        Spinner,
        Checkbox,
        Modal,
        FileUpload,
        Loading,
        MultiselectOption,
        Breadcrumbs,
        Field,
        NextButton,
        NextEditor,
    },
    inject: ['downloadFile'],
    computed: {
        ...mapGetters([
            'isNewBusiness',
            'hasPermission',
            'me',
        ])
    },
    props: {
        fid: [Number, String],
    }
})
export default class DettaglioFornitore extends Vue {

    tipo = 0
    estera = true
    aziendaAutocomplete: any = setup(() => Autocomplete(aziendeManager))

    fid!: number | string
    loading = false
    visible = false
    cm_visible = -1
    forceApproved = true
    approvaModalVisible = false
    approvaError = ''

    to_delete_quadro = []
    allegati_quadro: any[] = []
    uploaded_quadro: any[] = []
    uploaded_quadro_to_save = []


    to_delete_polizze = []
    allegati_polizze = []
    uploaded_polizze = []
    uploaded_polizze_to_save = []
    polizze_visible = false
    polizze_link = ''

    to_delete_visure = []
    allegati_visure = []
    uploaded_visure = []
    uploaded_visure_to_save = []
    visure_visible = false
    visure_link = ''

    to_delete_albo = []
    allegati_albo = []
    uploaded_albo = []
    uploaded_albo_to_save = []
    albo_visible = false
    albo_link = ''

    links_albo = []
    links_visure = []
    links_polizze = []

    links_albo_to_save: any[] = []
    links_visure_to_save: any[] = []
    links_polizze_to_save: any[] = []

    polizze_errors: any = {}
    visure_errors: any = {}
    albi_errors: any = {}
    marker!: any
    greenIcon!: any

    allegati = []

    get requiredPolizze() {
        return this.settore_merceologico_autocomplete.selection.some((e: any) => e.polizza)
    }

    get requiredVisure() {
        // return this.settore_merceologico_autocomplete.selection.some((e: any) => e.visura)
        return this.requiredPolizze || this.requiredAlbi
    }

    get requiredAlbi() {
        return this.settore_merceologico_autocomplete.selection.some((e: any) => e.albo_gestori)
    }

    fornitore_data: any = {};

    so = setup(() => {
        return ProvinciaComune()
    })

    hasPermission!: (perm: string) => void

    get toApprove() {
        return this.fornitore_model.approvato == null && this.hasPermission('approve fornitori') && !this.forceApproved;
    }

    approvaFornitore(approva: boolean) {
        fornitoriManager.approvazione(this.fid, approva).then((response) => {
            this.approvaModalVisible = false
            this.forceApproved = true
        }).catch(() => {
            this.approvaError = 'Si è verificato un errore'
        })
    }

    anagrafica_gamma: any = {}
    anagrafica_gamma_loading = false

    fornitore_model: any = {
        approvato: null,
        estera: false,
        tipo: null,
        denominazione: null,
        partita_iva: null,
        ragione_sociale: null,
        codice_fiscale: null,
        sito: null,
        sede_legale_via: null,
        sede_legale_numero: null,
        sede_legale_cap: null,
        sede_legale_comune_id: null,
        sede_legale_provincia_id: null,
        sede_legale_nazione_id: null,
        sede_legale_regione_estero: null,
        sede_legale_citta_estero: null,
        sede_operativa_via: null,
        sede_operativa_numero: null,
        sede_operativa_cap: null,
        sede_operativa_comune_id: null,
        sede_operativa_provincia_id: null,
        sede_operativa_nazione_id: null,
        sede_operativa_regione_estero: null,
        sede_operativa_citta_estero: null,
        gruppo_di_appartenenza: null,
        email: null,
        pec: null,
        qualifica: null,
        note: null,
        accordo_quadro: false,
        allegati_albo: [],
        allegati_polizze: [],
        allegati_visure: [],
        settori_merceologici: [],
        aziende_gruppo: [],
        lat: null,
        lng: null,
        place_id: null,
        a_lat: null,
        a_lng: null,
        a_place_id: null,
        ibans: [{
            iban: null,
            descrizione: null
        }],
        allegati: [],
    }
    settore_merceologico_autocomplete: any = setup(() => Autocomplete(settoriMerceologiciManager, true))
    qualifica_autocomplete: any = setup(() => Autocomplete(qualificheManager))

    settoriSelections = []
    disable_dati_azienda = false
    show_error_form = false
    id_gamma_search_timeout = 0

    get getBreadcrumbsPath(): Paths[] {
        return dettaglio_fornitore
    }

    get UploadedPolizze() {
        if (this.uploaded_polizze.length) {
            return this.uploaded_polizze
        }
        return [{name: 'allega'}]
    }

    onAddressInformationChange(address: any) {
        this.fornitore_model.sede_operativa_via = address.route
        this.fornitore_model.sede_operativa_numero = address.street_number
        this.fornitore_model.sede_operativa_cap = address.postal_code
        this.fornitore_model.sede_operativa_regione_estero = address.region
        this.fornitore_model.sede_operativa_citta_estero = address.locality
        this.so.disableProvinciaWatcher = true
        this.so.na_search(address.country).then(() => {
            this.so.na_selection = this.so.na_options.find((e: any) => e.nome.toLowerCase() == address?.country?.toLowerCase())
            return this.so.pa_search(address?.province)
        }).then(() => {
            this.so.pa_selection = this.so.pa_options.find((e: any) => e.codice.toLowerCase() == address?.province?.toLowerCase())
            return this.so.ca_search(address?.locality)
        }).then(() => {
            this.so.ca_selection = this.so.ca_options.find((e: any) => e.nome.toLowerCase() == address?.locality?.toLowerCase())
        }).finally(() => {
            this.so.disableProvinciaWatcher = false
        })
    }

    anagraficheAutocompleteSarch($event: any, timeout = 500) {
        this.aziendaAutocomplete.search($event, timeout).then(() => {
            this.aziendaAutocomplete.options.map((e: any) => {
                e['$isDisabled'] = true
            })
        })
    }

    @Watch('so.pa_selection')
    sede_operativa_provincia(new_value: any, old: any) {
        this.fornitore_model.sede_operativa_provincia_id = new_value?.id || new_value
    }

    @Watch('so.na_selection')
    sede_operativa_nazione(new_value: any, old: any) {
        this.fornitore_model.sede_operativa_nazione_id = new_value?.id || new_value
    }

    @Watch('so.ca_selection')
    sede_operativa_comune(new_value: any, old: any) {
        this.fornitore_model.sede_operativa_comune_id = new_value?.id || new_value
    }

    @Watch('aziendaAutocomplete.selection')
    azienda(new_value: any, old: any) {
        if (new_value && new_value.id < 0) {
            // permetto di modificare solo se sto inserendo un valore non esistente
            this.fornitore_model.partita_iva = new_value?.partita_iva
        } else if (!new_value) {
            this.fornitore_model.partita_iva = null
        }
    }

    rebindValue(data: any) {
        this.allegati_albo = data.allegati_albo
        this.allegati_polizze = data.allegati_polizze
        this.allegati_visure = data.allegati_visure
        this.allegati = data.allegati.map((e: any) => {
            return {file: e, type: e.type}
        })

        this.links_albo = data.link_albo
        this.links_visure = data.link_visure
        this.links_polizze = data.link_polizze

        this.fornitore_model.qualifica = data.qualifica

        if (data.quadro_file_id) {
            this.allegati_quadro = [data.quadro_file]
        }
        this.fornitore_model.accordo_quadro = data.accordo_quadro

        this.uploaded_albo_to_save.splice(0)
        this.uploaded_visure_to_save.splice(0)
        this.uploaded_polizze_to_save.splice(0)
        this.links_albo_to_save.splice(0)
        this.links_visure_to_save.splice(0)
        this.links_polizze_to_save.splice(0)
    }

    created() {
        fornitoriManager.fornitore(this.fid).then(res => {
            this.fornitore_model = {...this.fornitore_model, ...res.data}
            this.rebindValue(res.data)
            // this.tipo_model = this.tipo_options.find((o) => {
            //     return o.id == this.fornitore_model.tipo
            // })
            this.forceApproved = false
            return this.fornitore_model
        }).then(() => {
            this.so.na_retrieve(this.fornitore_model.sede_operativa_nazione_id)
            this.so.pa_retrieve(this.fornitore_model.sede_operativa_provincia_id).then(() => {
                this.so.ca_retrieve(this.fornitore_model.sede_operativa_comune_id)
            })
            fornitoriManager.settori(this.fid).then(res => {
                this.settore_merceologico_autocomplete.options = res.data
                this.settore_merceologico_autocomplete.selection = res.data
            })
            this.aziendaAutocomplete.retrieve(this.fornitore_model.azienda_id)
            this.qualifica_autocomplete.retrieve(this.fornitore_model.qualifica)
            this.qualifica_autocomplete.search('', 0)
            this.settore_merceologico_autocomplete.search('', 0)

        })
    }

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    @Watch('settore_merceologico_autocomplete.selection')
    committente(new_value: any, old: any) {
        this.fornitore_model.settori_merceologici = new_value.map((e: any) => e.id)
    }

    @Watch('qualifica_autocomplete.selection')
    qualifica(new_value: any, old: any) {
        this.fornitore_model.qualifica = new_value.id
    }

    @Watch('fornitore_model.id_gamma', {deep: true})
    id_gamma(new_value: any, old: any) {
        if (this.id_gamma_search_timeout > 0) {
            clearTimeout(this.id_gamma_search_timeout);
            this.id_gamma_search_timeout = 0
        }
        if (new_value) {
            this.anagrafica_gamma_loading = true
            // @ts-ignore
            this.id_gamma_search_timeout = setTimeout(() => {
                anagraficaGamma.clienteGamma(new_value).then((response: any) => {
                    this.anagrafica_gamma = response.data
                }).finally(() => {
                    this.anagrafica_gamma_loading = false
                })
            }, 500)
        } else {
            this.anagrafica_gamma = {}
        }
    }

    save() {
        this.loading = true
        this.fornitore_model.allegati_albo = this.allegati_albo.map((e: any) => e.id).concat(this.uploaded_albo_to_save.map((e: any) => e.id))
        this.fornitore_model.allegati_visure = this.allegati_visure.map((e: any) => e.id).concat(this.uploaded_visure_to_save.map((e: any) => e.id))
        this.fornitore_model.allegati_polizze = this.allegati_polizze.map((e: any) => e.id).concat(this.uploaded_polizze_to_save.map((e: any) => e.id))

        this.fornitore_model.links_albo = this.links_albo.map((e: any) => e.id).concat(this.links_albo_to_save.map((e: any) => e.id))
        this.fornitore_model.links_visure = this.links_visure.map((e: any) => e.id).concat(this.links_visure_to_save.map((e: any) => e.id))
        this.fornitore_model.links_polizze = this.links_polizze.map((e: any) => e.id).concat(this.links_polizze_to_save.map((e: any) => e.id))

        this.fornitore_model.allegati = this.allegati.map((e: any) => {
            return {file_id: e.file?.id, type: e.type}
        })

        // se ho effettivamente caricato dei file li uploado
        if (this.uploaded_quadro.length) {
            this.fornitore_model.quadro_file_id = this.uploaded_quadro.pop()?.id || null
        }

        fornitoriManager.fornitoriUpdate(this.fid, this.fornitore_model).then((res) => {
            this.errors = {}
            this.rebindValue(res.data)
            this.show_error_form = false
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
                this.show_error_form = true
            }
        }).finally(() => {
            this.loading = false
        })
    }

    chiudiPolizze() {
        this.uploaded_polizze.splice(0)
        this.polizze_visible = false
        this.polizze_link = ''
        this.polizze_errors = {}
    }

    resetpPolizze() {
        this.polizze_visible = false
        this.polizze_link = ''
        this.polizze_errors = {}
    }

    salvaPolizze() {
        if (this.polizze_link) {
            linksManager.polizzaLinkCreate({links: [this.polizze_link]}).then((res: any) => {
                this.links_polizze_to_save.push(...res.data)
                this.resetpPolizze()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.polizze_errors = res.response.data.errors
                }
            })

        } else {
            this.uploaded_polizze_to_save.push(...this.uploaded_polizze.splice(0))
            this.resetpPolizze()
        }
    }

    chiudiVisure() {
        this.uploaded_visure.splice(0)
        this.visure_visible = false
        this.visure_link = ''
        this.visure_errors = {}
    }

    resetVisure() {
        this.visure_visible = false
        this.visure_link = ''
        this.visure_errors = {}
    }

    salvaVisure() {
        if (this.visure_link) {
            linksManager.visureLinkCreate({links: [this.visure_link]}).then((res: any) => {
                this.links_visure_to_save.push(...res.data)
                this.resetVisure()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.visure_errors = res.response.data.errors
                }
            })
        } else {
            this.uploaded_visure_to_save.push(...this.uploaded_visure.splice(0))
            this.resetVisure()
        }
    }

    chiudiAlbo() {
        this.uploaded_albo.splice(0)
        this.albo_visible = false
        this.albo_link = ''
        this.albi_errors = {}
    }

    resetAlbi() {
        this.albo_visible = false
        this.albo_link = ''
        this.albi_errors = {}
    }

    salvaAlbo() {
        if (this.visure_link) {
            linksManager.albiLinkCreate({links: [this.albo_link]}).then((res: any) => {
                this.links_albo_to_save.push(...res.data)
                this.resetAlbi()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.albi_errors = res.response.data.errors
                }
            })
        } else {
            this.uploaded_albo_to_save.push(...this.uploaded_albo.splice(0))
            this.resetAlbi()
        }
    }
}

</script>


<style lang="scss" scoped>
#map {
    z-index: 1;
    height: 400px;
}
</style>
